export default __webpack_public_path__ + "static/media/react.80045de7.png";